import { skipToken } from "@reduxjs/toolkit/query";
import { useGetProjectQuery, useGetSourcingEventQuery } from "../../autogen/bff-api";
import { isNotFoundError } from "../errors/isNotFoundError";
import { urls } from "../../urls";
import type { AnsweredOn } from "./conversationSubject";

export type CaseNow = { gone: true } | { gone: false; found: boolean; title: string | undefined; referenceId: string | null | undefined };

const FRESH = { refetchOnMountOrArgChange: true } as const;

export const casePath = (subject: AnsweredOn): string | undefined => {
  if (subject.kind === "v2Event") return urls.app.sourcingEvents.view.go(subject.id);
  if (subject.kind === "project") return urls.app.projects.view.go(subject.id);
  return undefined;
};

export const useCaseNow = (subject: AnsweredOn | undefined): CaseNow => {
  const event = useGetSourcingEventQuery(subject?.kind === "v2Event" ? { eventId: subject.id } : skipToken, FRESH);
  const project = useGetProjectQuery(subject?.kind === "project" ? { projectId: subject.id } : skipToken, FRESH);
  if (isNotFoundError(event.error) || isNotFoundError(project.error)) return { gone: true };
  const read = subject?.kind === "v2Event" ? event : project;
  return {
    gone: false,
    found: read.isSuccess && !read.isFetching && read.data !== undefined,
    title: event.data?.eventData.title ?? project.data?.name,
    referenceId: event.data?.eventData.referenceId,
  };
};
